<template>
    <div class="admin-trader-creation-form container">
        <div class="row py-5">
            <div class="col-12">
                <h1 class="pstitle">
                    <a href="/admin/cms">Admin CMS</a>
                    <span> - </span>
                    <a href="/admin/cms/trader">Trader Creation</a>
                </h1>
            </div>
        </div>

        <div class="col-sm-12 text-end form-options">
            <a href="javascript:void(0)" class="pt-1 cursor" :onclick="handleAdvancedOptions" aria-label="Advanced Mode">Advanced Mode</a>
            <a href="javascript:void(0)" class="pt-1 cursor" :onclick="handleReset" aria-label="Reset Form">Reset</a>
        </div>

        <div class="row py-5">
            <div class="col-xs-12 col-md-3">
                <input type="text"
                       class="form-control"
                       id="selectedBrand"
                       required
                       placeholder="mastercraft"
                       v-model="selectedBrand" />
                <label for="selectedBrand" class="form-label">Brand Name</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <input type="text"
                       class="form-control"
                       id="selectedName"
                       placeholder="MC Trader"
                       v-model="selectedName" />
                <label for="selectedName" class="form-label">Trader Instance Name</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <SelectOption v-model="selectedActiveBrand"
                              :options="activeBrand"
                              id="activeBrand"
                              class="form-control" />
                <label for="activeBrand" class="form-label">Trader Brands</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <country-dropdown :oncountryload="InitialSelect"
                                  :onchange="selectedCountry"
                                  id="country" />
                <label for="country" class="form-label">Country</label>
            </div>
        </div>

        <div class="row py-3">
            <div class="col-xs-12 col-md-3">
                <input type="text"
                       class="form-control"
                       id="addressLine1"
                       placeholder="100 Cherokee Cove Dr"
                       v-model="addressLine1" />
                <label for="addressLine1" class="form-label">Address</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <input type="text"
                       class="form-control"
                       id="city"
                       placeholder="Vonore"
                       v-model="city" />
                <label for="city" class="form-label">City</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <input type="text"
                       class="form-control"
                       id="zip"
                       placeholder="Zip / Postal Code"
                       v-model="zip" />
                <label for="zip" class="form-label">Zip</label>
            </div>
            <div class="col-xs-12 col-md-3">
                <states-dropdown :CountryCode="country"
                                 :onchange="selectedState"
                                 v-model="state"
                                 id="state" />
                <label for="state" class="form-label">State</label>
            </div>
        </div>

        <div class="row py-3">
            <div class="col-xs-12 col-md-4">
                <input type="text"
                       class="form-control"
                       id="domain"
                       placeholder="trader.mastercraft.com"
                       v-model="domain"
                       :disabled="!showAdvancedOptions" />
                <label for="domain" class="form-label">Domain</label>
            </div>
            <div class="col-xs-12 col-md-4">
                <input type="text"
                       class="form-control"
                       id="dealerNo"
                       placeholder="nation-search"
                       v-model="dealerNo"
                       :disabled="!showAdvancedOptions" />
                <label for="dealerNo" class="form-label">DealerNo</label>
            </div>
        </div>

        <div class="flex justify-content-end">
            <span class="me-3 pt-2">{{ saveMessage }}</span>
            <custom-button class="btn-main"
                    v-on:btnClicked="handleCreateClick">
                Create Trader
            </custom-button>
        </div>

        <modal-card v-model="showConfirmCreate"
                    title="Confirm Trader Creation"
                    size="md">
            <p>Create a new trader with these details?</p>

            <dl class="trader-summary text-black">
                <dt>Trader Name</dt>  <dd>{{ pendingTrader.name }}</dd>
                <dt>Brand</dt>        <dd>{{ selectedActiveBrand }}</dd>
                <dt>Domain</dt>       <dd>{{ pendingTrader.micrositeDomain }}</dd>
                <dt>DealerNo</dt>     <dd>{{ pendingTrader.dealerNo }}</dd>
                <dt>Address</dt>
                <dd>
                    {{ pendingTrader.addressLine1 }}<br />
                    {{ pendingTrader.city }}, {{ pendingTrader.state }} {{ pendingTrader.postalCode }}<br />
                    {{ pendingTrader.country }}
                </dd>
            </dl>

            <p class="text-danger mb-0">This adds a new dealer location to the database and can't be undone from the CMS.</p>

            <template #footer="{ close }">
                <custom-button class="btn-main" v-on:btnClicked="close">
                    Cancel
                </custom-button>
                <custom-button class="btn-main" v-on:btnClicked="handleConfirm">
                    Create
                </custom-button>
            </template>
        </modal-card>
    </div>
</template>

<script>
import SelectOption from "../../components/atoms/SelectOption.vue";
import StatesDropdown from "../../components/atoms/StatesDropdown.vue";
import CountryDropdown from "../../components/atoms/CountryDropdown.vue";
import CustomButton from "../../components/atoms/CustomButton.vue";
import ModalCard from "../../components/atoms/ModalCard.vue";

export default {
    name: "TraderCmsPage",
    components: {
        SelectOption,
        CustomButton,
        CountryDropdown,
        StatesDropdown,
        ModalCard,
    },
    data() {
        return {
            selectedBrand: "",
            selectedName: "",
            domain: "",
            dealerNo: "",
            selectedActiveBrand: "",
            activeBrand: [
                { value: "mastercraft" },
                { value: "crest" },
                { value: "balise" },
                { value: "chaparral" },
                { value: "robalo" },
                // More will be added when the Is<Dealer> columns in the db are added
            ],

            addressLine1: "",
            city: "",
            zip: "",
            country: "",
            state: "",

            showAdvancedOptions: false,
            loading: false,
            saveMessage: "",

            showConfirmCreate: false,
            pendingTrader: {},
        };
    },
    methods: {
        handleAdvancedOptions() {
            this.showAdvancedOptions = !this.showAdvancedOptions;
        },

        handleReset() {
            // Clearing selectedBrand also clears domain and dealerNo via the watcher
            this.selectedBrand = "";
            this.selectedName = "";
            this.selectedActiveBrand = "";
            this.addressLine1 = "";
            this.city = "";
            this.zip = "";
            this.state = "";
            this.saveMessage = "";
        },

        // Single place the payload is built, used by both the modal summary and the request
        buildTrader() {
            return {
                dealerNo: this.dealerNo,
                name: this.selectedName,
                micrositeDomain: this.domain,
                addressLine1: this.addressLine1,
                city: this.city,
                state: this.state !== "" ? this.state : document.getElementById("state").value,
                country: this.country,
                postalCode: this.zip,
                isCrestDealer: this.selectedActiveBrand === "crest",
                isMastercraftDealer: this.selectedActiveBrand === "mastercraft",
            };
        },

        handleCreateClick() {
            if (this.loading) return;

            const required = [
                ["Brand Name", this.selectedBrand],
                ["Trader Instance Name", this.selectedName],
                ["Trader Brands", this.selectedActiveBrand],
                ["Domain", this.domain],
                ["DealerNo", this.dealerNo],
            ];
            const missing = required
                .filter(([, value]) => !value || !String(value).trim())
                .map(([label]) => label);

            if (missing.length > 0) {
                this.saveMessage = "Missing: " + missing.join(", ") + ".";
                return;
            }

            this.saveMessage = "";
            this.pendingTrader = this.buildTrader();
            this.showConfirmCreate = true;
        },

        handleConfirm() {
            this.showConfirmCreate = false;
            this.createSubmit();
        },

        createSubmit() {
            if (this.loading) return;   // guard against double-clicks

            this.loading = true;
            this.saveMessage = "Creating...";
            this.axios
                .post("/admin/trader", this.pendingTrader)
                .then((response) => {
                    this.loading = false;
                    this.saveMessage = "Trader created.";
                    console.log("Trader created:", response.data);
                })
                .catch((err) => {
                    this.loading = false;
                    this.saveMessage = "Create failed (" + (err.response?.status ?? "network error") + ").";
                    console.log(err);
                });
        },

        InitialSelect(data) {
            this.country = data;
        },
        selectedCountry(event) {
            this.country = event.target.value;
        },
        selectedState(event) {
            this.state = event.target.value;
        },
    },
    watch: {
        selectedBrand(newValue) {
            const brand = (newValue || "").trim().toLowerCase();
            this.domain = brand ? `trader.${brand}.com` : "";
            this.dealerNo = brand ? `nation-search-${brand}` : "";
        },
    },
};
</script>

<style lang="scss">
.admin-trader-creation-form {
    .form-control {
        appearance: auto;
    }

    .row {
        row-gap: 1rem;
    }

    // Keep the label floated above the field even while the placeholder is showing
    .row .form-control + .form-label {
        top: -45px;
    }

    .form-options {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }
}

// The modal is teleported to <body>, so this can't be nested under the page class
.trader-summary {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 0.25rem 1rem;
    margin-bottom: 1rem;

    dt {
        font-weight: bold;
    }

    dd {
        margin: 0;
    }
}
</style>